<style lang="scss" scoped>
  span {
    cursor: pointer;
  }
</style>

<template>
  <div class="d-flex">
    <img
      class="mr-2"
      src="/build/icons/phone-circle.svg"
      alt="Phone"
      width="16"
      height="16"
      v-if="roundIcon"
    ><img
      class="mr-1 mt-3px"
      src="/build/icons/phone.svg"
      alt="Phone"
      width="13"
      height="13"
      v-else
    >
    <span
      @click.prevent="endCall()"
      v-if="active"
    >
      {{ integrations[integration.name].textStatus() }}
      <span
        v-b-tooltip.right="'Clique para finalizar'"
        :class="customClass"
        v-if="integration === 'tel'"
      >
        <i class="fa fa-stop" />
      </span>
    </span>
    <span v-else>
      <span
        v-for="(phone, index) in phoneNumbers()"
        :key="index"
        v-if="phone"
      >
        <template v-if="!validPhones[index]">
          <span style="cursor: default"> {{ phone }} - {{ __('Número inválido') }}!</span>
        </template>
        <template v-else>
          <a class="mr-3" :href="'tel:' + validPhones[index]" :class="customClass" v-if="!integration">
            {{ validPhones[index] }}
          </a>
          <span class="mr-3" v-b-tooltip.right="'Clique para ligar: ' + validPhones[index]" :class="customClass" @click.prevent="startCall(validPhones[index].slice(2))" v-else>
            {{ validPhones[index] }}
          </span>
        </template>
      </span>
    </span>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import Api4Com from './Api4Com';
import Sonax from './Sonax';
import Telephony from './Telephony';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    hash: {
      required: true,
    },
    phones: {
      required: true,
    },
    validPhones: {
      required: true,
    },
    user: {
      required: true,
    },
    roundIcon: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: '',
    },
  },

  created () {
    Bus.$on(`startCall-${this.hash}`, () => this.active = true);
    Bus.$on(`endCall-${this.hash}`, () => this.active = false);
    Bus.$on(`saveActivity-${this.hash}`, (hash, activity) => this.saveActivity(hash, activity));

    Bus.$on('integrationClickToCall', (integration) => this.set(integration));
  },

  data () {
    return {
      active: false,
      integration: '',
      integrations: {
        tel: new Telephony(),
        sonax: new Sonax(),
        api4com: new Api4Com(),
      },
    };
  },

  methods: {
    phoneNumbers () {
      return this.phones.map((phone) => phone.replace(/[^0-9]/g, ''));
    },

    set (integration) {
      this.integration = integration;
    },

    startCall (called) {
      this.integration.config.called = called,
      this.integration.config.data = {
        hash: this.hash,
        user: this.user.id,
        token: this.user.account,
      };

      this.integrations[this.integration.name].startCall(this.integration.config);
    },

    endCall () {
      this.integrations[this.integration.name].endCall();
    },

    saveActivity (hash, activity) {
      this.$http.post(`/lead/${hash}/activity`, activity)
        .then(({ data }) => {
          Bus.$emit(`lead.${hash}.activity`, data);
        })
        .catch(() => {
          Alert.error(this.__('Erro ao salvar atividade.'));
        });
    },
  },
};
</script>
